import BaseModel from "lib/model";
import BaseCollection from "lib/collection";

const Subteam = BaseModel.extend({
    props: {
        _id: "objectId",
        name: "string",
        email_list: "array",
    },
});

const Subteams = BaseCollection.extend({
    mainIndex: "name",
    model: Subteam,
});

// This module will get expanded to all brand data when redoing gallery
export default BaseModel.extend({
    props: {
        preferences: "array",
        currencies: "array",
        default_currency: { type: "string", required: true, default: "USD" },
        default_locale: { type: "string", default: "en-us" },
        pricesheets: "array",
        pricing_templates: "array",
        missing_logo_image: { type: "string", default: "" },
        email_header_image: { type: "string", default: "" },
        email_logo_image: { type: "string", default: "" },
        warehouses: "array",
        available_order_actions: "array",
        inventory_reservation: "object",
        dashboard_logo_image: "string",
        pdf_logo_image: "string",
        order_split_fields: "array",
        reorder_field_exclusions: "array",
        order_quantity_rules: "array",
        order_recap: "object",
        custom_roles: "array",
        digest_email_list: "array",
        published_seasons: "array",
        guest_buyer_product_whitelist_values: "array",
        subscription_type: "string",
        subscription_tier: "string",
        nuorder_processor_statement_email_list: "array",
        catalog_import_transformations: "array",
        image_formats: "object",
        standard_image_format: "string",
        image_format_separator: "string",
        image_format_convention: "string",
        image_formats_name: "string",
        image_formats_description: "string",
        image_formats_modified_on: "utcDate",
        alternative_image_formats: "array",
        enable_pages_manager: "boolean",
        strikethrough: "object",
        external_pricing: "object",
        volume_pricing_customization_scripts: "string",
        watermarking: "object",
        // we don't make it a collection, because of how basemodel works (it defaults optional attribute objects to {})
        customizations_image_tag_schemas: "array",
        product_customizations: "object",
        google_analytics: "object",
        marketplace: "object",
        part_of_marketplace: "boolean",
        open_in_marketplace: "boolean",
    },

    collections: {
        subteams: Subteams,
    },

    derived: {
        _prefs: {
            deps: ["preferences"],
            fn() {
                const prefs = {};
                this.preferences.forEach(function (pref) {
                    prefs[pref.preference] = pref.value;
                });
                return prefs;
            },
        },
    },
    /*
    collections: {
        warehouses: Warehouses
    }
    */
});
